import { Link } from 'react-router-dom'

interface FinalCtaProps {
  title?: string
  text?: string
}

export function FinalCta({
  title = 'Ready to request notary service?',
  text = 'Share the practical details. Michael will confirm availability, travel, and final pricing before anything is scheduled.',
}: FinalCtaProps) {
  return (
    <section className="final-cta">
      <div className="container final-cta-inner">
        <div><span className="eyebrow eyebrow-light">Clear next steps</span><h2>{title}</h2><p>{text}</p></div>
        <div className="hero-actions"><Link className="button button-light" to="/request-appointment">Request an appointment</Link><Link className="text-link text-link-light" to="/pricing">Review pricing <span aria-hidden="true">→</span></Link></div>
      </div>
    </section>
  )
}
